var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83951 3.99902V0.999023C3.83951 0.733807 3.94064 0.479453 4.12065 0.291917C4.30066 0.10438 4.54481 -0.000976562 4.79938 -0.000976562H16.3179C16.5725 -0.000976562 16.8166 0.10438 16.9966 0.291917C17.1766 0.479453 17.2778 0.733807 17.2778 0.999023V14.999C17.2778 15.2642 17.1766 15.5186 16.9966 15.7061C16.8166 15.8937 16.5725 15.999 16.3179 15.999H13.4383V18.999C13.4383 19.551 13.0063 19.999 12.4717 19.999H0.966596C0.840014 19.9998 0.71453 19.9745 0.597353 19.9247C0.480176 19.8748 0.373616 19.8012 0.283796 19.7083C0.193976 19.6154 0.122665 19.5049 0.0739626 19.3832C0.0252597 19.2614 0.000124183 19.1309 0 18.999L0.00287965 4.99902C0.00287965 4.44702 0.434824 3.99902 0.969476 3.99902H3.83951ZM1.92263 5.99902L1.91975 17.999H11.5185V5.99902H1.92263ZM5.75926 3.99902H13.4383V13.999H15.358V1.99902H5.75926V3.99902Z",
    fill: "#6B6C7E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3e8e58cbcc288c40fef5f794f3a5b730.svg";
export { ForwardRef as ReactComponent };